// extracted by mini-css-extract-plugin
module.exports = {"skeletonCard":"skeletonCard_skeletonCard__O6BeP","circleSkelton":"skeletonCard_circleSkelton__1fmIH","rightSkeleton":"skeletonCard_rightSkeleton__1GbRQ"};